var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-overlay',{attrs:{"show":_vm.loading,"fixed":"","no-wrap":"","variant":"transparent","blur":"20px"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }